<ng-content select="[dashboard-card-header]"></ng-content>
<ng-content select="[dashboard-card-content]"></ng-content>
<ng-content select="[dashboard-card-footer]"></ng-content>
<ng-content></ng-content>

